<template>
    <div class="scheduler shrinker" ref="schedulerEl">
        <div class="scheduler__box">
            <div class="scheduler__inner">
                <div class="breakout-track" v-if="view == 'track'">
                    <div class="align--center">
                        <h2 class="h1">
                            Track &mdash; <span class="accent--orange">{{ track.category }}</span>
                        </h2>
                    </div>

                    <div class="row">
                        <div class="col-medium-1-2 event-card__container" v-for="(session, index) in trackSessions">
                            <SessionCard v-on:clickTimeslot="showTimeslotBySession" v-on:clickSession="showSession" :session="session" v-bind:class="{ 'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3}"></SessionCard>
                        </div>
                    </div>
                </div>

                <div class="timeslot" v-if="view == 'timeslot'">
                    <div class="align--center">
                        <h2 class="h1 m-b-0">
                            Timeslot &mdash; <span class="accent--orange">{{ timeslot.name }}</span>
                        </h2>
                        <div class="timeslot__time" v-html="getTimeslotTime()"></div>
                    </div>

                    <div class="row">
                        <div class="col-medium-1-2 event-card__container" v-for="(session, index) in timeslotSessions">
                            <SessionCard v-on:clickTimeslot="showTimeslotBySession" v-on:clickSession="showSession" :date-link="false" :session="session" v-bind:class="{ 'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3}"></SessionCard>
                        </div>
                    </div>
                </div>

                <div class="session" v-if="view == 'session'">
                    <div class="align--center">
                        <div class="h1">
                            Breakout Description
                        </div>
                        <h2 class="session__title">
                            {{ session.eventSessionTitle }}
                        </h2>
                    </div>

                    <div class="session__details">
                        <div class="session__detail">
                        <span class="session__detail-label">
                            Timeslot
                        </span>
                            <span class="session__detail-value">
                            <a href="#" v-on:click.prevent="showTimeslot(session.eventSessionTimeSlot)" v-html="session.eventSessionTimeSlot + ' - ' + showTime(session.eventSessionStartDT, session.eventSessionEndDT) "></a>
                        </span>
                        </div>
                        <div class="session__detail">
                        <span class="session__detail-label">
                            Room
                        </span>
                            <span class="session__detail-value">
                            {{ session.eventSessionLocation }}
                        </span>
                        </div>
                        <div class="session__detail">
                        <span class="session__detail-label">
                            Speakers
                        </span>
                            <span class="session__detail-value">
                            <span v-for="speaker in sessionSpeakers">
                                <a href="#" v-on:click.prevent="showSpeaker(speaker)">{{ speaker.name }}</a>
                            </span>
                        </span>
                        </div>
                        <div class="session__detail">
                        <span class="session__detail-label">
                            Tracks
                        </span>
                            <span class="session__detail-value">
                            <span v-for="track in sessionTracks">
                                <a href="#" v-on:click.prevent="showTrack(track)">{{ track.category }}</a>
                            </span>
                        </span>
                        </div>
                    </div>

                    <div class="align--center">
                        <div class="h1">
                            About
                        </div>
                    </div>
                    <div class="session__description">
                        {{ session.eventSessionDescription }}
                    </div>
                </div>

                <div class="speaker" v-if="view == 'speaker'">
                    <div class="speaker__bio-name">
                        {{ speaker.name }}
                    </div>
                    <div class="speaker__photo" v-bind:style="{ backgroundImage: 'url(' + speaker.webPhoto + ')' }"></div>
                    <div class="speaker__about-header">
                        Speaker Bio
                    </div>
                    <div class="speaker__bio">
                        {{ speaker.bio }}
                    </div>

                    <div v-if="speakerSessions">
                        <div class="row row--center">
                            <div class="col-medium-1-2" v-for="timeslot in speakerTimeslotTypes">
                                <div v-if="timeslot == 'Breakout'">
                                    <div class="speaker__timeslot-header speaker__timeslot-header--breakout">
                                        <div class="speaker__timeslot-header-top">Conference</div>
                                        <div class="speaker__timeslot-header-big">Breakout</div>
                                    </div>
                                    <div class="event-card__container" v-for="(session, index) in speakerSessions">
                                        <SessionCard v-if="session.eventSessionTimeSlot.indexOf(timeslot) != -1" v-on:clickTimeslot="showTimeslotBySession" v-on:clickSession="showSession" :session="session" v-bind:class="{ 'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3}"></SessionCard>
                                    </div>
                                </div>
                                <div v-if="timeslot == 'Workshop'">
                                    <div class="speaker__timeslot-header speaker__timeslot-header--workshop">
                                        <div class="speaker__timeslot-header-top">Youlead</div>
                                        <div class="speaker__timeslot-header-big">Workshop</div>
                                    </div>
                                    <div class="event-card__container" v-for="(session, index) in speakerSessions">
                                        <SessionCard v-if="session.eventSessionTimeSlot.indexOf(timeslot) != -1" v-on:clickTimeslot="showTimeslotBySession" v-on:clickSession="showSession" :session="session" v-bind:class="{ 'event-card--alt': (index + 1) % 4 == 0 || (index + 1) % 4 == 3}"></SessionCard>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<div v-if="speakerTimeslotTypes.length == 2">-->
                            <!---->
                        <!--</div>-->
                        <div v-else>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import axios from 'axios'
    import dateFormat from 'dateformat'
    import SessionCard from './SessionCard.vue'
    import ArrowBack from '../../images/arrow-back.svg'
    import scrollToElement from 'scroll-to-element'
    import IconX from '../../images/icon-x.svg'

    export default {

        components: {
            ArrowBack,
            SessionCard,
            IconX
        },

        props: [
            'track',
            'sessions',
            'speakers',
            'openTimeslot',
            'openView',
            'breakoutTracks',
            'timeslot',
            'timeslots',
            'speaker'
        ],

        data: function() {
            return {
                sessions: null,
                session: null,
                speakers: null,
                view: null,
                track: {
                    name: null
                },
                trackSessions: [],
                timeslotSessions: [],
                sessionTracks: [],
                sessionSpeakers: [],
                speakerSessions: [],
                speakerTimeslotTypes: []
            }
        },

        methods: {
            getOrangeDate: function(date) {
                var dateParts = date.split(" ");
                var dayParts = dateParts[0].split('-');
                var timeParts = dateParts[1].split(':');

                return new Date(dayParts[0], dayParts[1], dayParts[2], timeParts[0], timeParts[1], timeParts[2]);
            },

            getTrackSessions: function(track) {
                this.trackSessions = [];
                if(track) {
                    for(var i = 0; i < this.sessions.length; i++) {
                        if(this.sessions[i].eventSessionCategories) {
                            if(this.sessions[i].eventSessionCategories.indexOf(track.catSequence) != -1) {
                                this.trackSessions.push(this.sessions[i]);
                            }
                        }
                    }
                }
            },

            showTime: function(startTime, endTime) {
                return dateFormat(this.getOrangeDate(startTime), 'dddd mmmm dS') + ' &bullet; ' +  dateFormat(this.getOrangeDate(startTime), 'h:MMTT') + ' - ' + dateFormat(this.getOrangeDate(endTime), 'h:MMTT');
            },

            getTimeslotSessions: function(timeslot) {
                this.timeslotSessions = [];
                if(timeslot) {
                    for(var i = 0; i < this.sessions.length; i++) {
                        if(this.sessions[i].eventSessionTimeSlot) {
                            if(this.sessions[i].eventSessionTimeSlot.indexOf(timeslot.name) != -1) {
                                this.timeslotSessions.push(this.sessions[i]);
                            }
                        }
                    }
                }
            },

            getSessionTracks: function(session) {
                this.sessionTracks = [];
                if(session) {
                    for(var i = 0; i < this.session.eventSessionCategories.length; i++) {
                        for(var j = 0; j < this.breakoutTracks.length; j++) {
                            if(this.breakoutTracks[j].catSequence == this.session.eventSessionCategories[i]) {
                                this.sessionTracks.push(this.breakoutTracks[j]);
                            }
                        }
                    }
                }
            },

            getSessionSpeakers: function(session) {
                this.sessionSpeakers = [];
                if(session) {

                    for(var i = 0; i < this.session.eventSessionSpeakers.length; i++) {
                        for(var j = 0; j < this.speakers.length; j++) {
                            if(this.speakers[j].rec == this.session.eventSessionSpeakers[i]) {
                                this.sessionSpeakers.push(this.speakers[j]);
                            }
                        }
                    }

                }
            },

            getSpeakerSessions: function(speaker) {
                this.speakerSessions = [];
                if(speaker) {
                    for(var i = 0; i < this.sessions.length; i++) {
                        if(this.sessions[i].eventSessionSpeakers) {
                            if(this.sessions[i].eventSessionSpeakers.indexOf(speaker.rec) != -1) {
                                this.speakerSessions.push(this.sessions[i]);
                            }
                        }
                    }
                }
            },

            getSpeakerTimeslotTypes: function() {
                this.speakerTimeslotTypes = [];
                var self = this;
                this.speakerSessions.forEach(session => {
                    if(session['eventSessionTimeSlot']) {
                        if(session['eventSessionTimeSlot'].indexOf('Breakout') !== -1) {
                            if(self.speakerTimeslotTypes.indexOf('Breakout') == -1) {
                                self.speakerTimeslotTypes.push('Breakout');
                            }
                        }
                        if(session['eventSessionTimeSlot'].indexOf('Workshop') !== -1) {
                            if(self.speakerTimeslotTypes.indexOf('Workshop') == -1) {
                                self.speakerTimeslotTypes.push('Workshop');
                            }
                        }
                    }
                });
            },

            getTimeslotTime: function() {
                return dateFormat(this.getOrangeDate(this.timeslot.startTime), 'dddd mmmm dS') + ' &bullet; ' +  dateFormat(this.getOrangeDate(this.timeslot.startTime), 'h:MMTT') + ' - ' + dateFormat(this.getOrangeDate(this.timeslot.endTime), 'h:MMTT');
            },

            getTimeslotByName: function(timeslotName) {
                for(var i = 0; i < this.timeslots.length; i++) {
                    if(this.timeslots[i].name == timeslotName) {
                        this.timeslot = this.timeslots[i];
                    }
                }
            },

            showSession: function(session) {
                this.session = session;
                this.view = 'session';
                this.getSessionTracks(session);
                this.getSessionSpeakers(session);
            },

            showTimeslot: function(timeslotName) {
                this.getTimeslotByName(timeslotName);
                this.view = 'timeslot';
                this.getTimeslotSessions(this.timeslot);
            },

            showTimeslotBySession: function(session) {
                this.showTimeslot(session.eventSessionTimeSlot);
            },

            showTrack: function(track) {
                this.track = track;
                this.getTrackSessions(track);
                this.view = 'track';
            },

            showSpeaker: function(speaker) {
                this.speaker = speaker;
                this.getSpeakerSessions(speaker);
                this.getSpeakerTimeslotTypes();
                this.view = 'speaker';
            }

        },

        created: function() {
            this.view = this.openView;
            this.getTrackSessions(this.track);
            this.getTimeslotSessions(this.timeslot);
            this.getSpeakerSessions(this.speaker);
        },

        watch: {
            view: function(val) {
                if(val == 'speaker') {
                    this.getSpeakerTimeslotTypes();
                }

                // Animate View and scroll to top
                var el = document.getElementById('modal-scroll');
                setTimeout(function() {
                    el.scrollTop = 0;
                }, 10);


                /*
                scrollToElement(el, {
                    offset: -100,
                    ease: 'out-circ',
                    duration: 500
                });
                */

            },

            session: function(val) {
            },

            timeslot: function(timeslot) {
            }
        }

    }
</script>


// WEBPACK FOOTER //
// ScheduleSwitcher.vue?34fe504d